<template>
  <div
    class="marker m-4 shadow round border index transition-all border-radius-1"
  >
    <div class="d-flex flex-row justify-content-start" @click="toChapter">
      <div class="row w-100 my-2 mx-2">
        <div class="col-12">
          <h3 class="font-weight-bold text-muted m-0">
            <b class="text-logo">{{ number }}.</b>
            {{ title }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "br-index-item",
  props: {
    title: {
      type: String,
      default: "Text Title test",
      description: "",
    },
    number: {
      type: [String, Number],
      default: "Marker text test into card.",
      description: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["stepToChapter", "showIndex"]),
    clicked() {
      this.$emit("clicked");
    },
    toChapter() {
      this.stepToChapter(this.number);
      this.showIndex();
    },
  },
};
</script>
